import type {
  InterventionTemplateDuplicateFormProps,
  InterventionTemplateDuplicateFormValues,
} from "./intervention-template-duplicate-form.type";
import type {
  InterventionTemplateEntity,
  InterventionTemplateDuplicateVariables,
} from "@/entities/intervention-template";

import { useModelDuplicateForm } from "@/modules/model-duplicate";

export const useInterventionTemplateDuplicateForm = ({
  template,
}: InterventionTemplateDuplicateFormProps) => {
  return useModelDuplicateForm<
    InterventionTemplateEntity,
    InterventionTemplateDuplicateFormValues,
    InterventionTemplateDuplicateVariables
  >({
    modelKey: "interventiontemplate",
    item: template,
    valuesToVariables: (values) => ({ name: values.name }),
    validationNames: ["name"],
  });
};
